import { css } from '@microsoft/fast-element';
export const foundationConnectionIndicatorStyles = (context, definition) => css `
  :host {
    --light-size: 12px;
    --height: calc(var(--design-unit) * 2px + var(--light-size));

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: var(--height);
    margin: calc(var(--design-unit) * 2px) 0;

    /* https://www.colorxs.com/color/traffic-light-green-2032-20 */
    --green: 50 164 49;
    --trafic-light-green: rgb(var(--green));
    --trafic-light-green-glow:
      rgb(var(--green) / 40%) 0 0 4px 4px,
      rgb(var(--green) / 20%) 0 0 8px 8px;

    /* https://www.colorxs.com/color/ral-3020-traffic-red */
    --red: 187 30 16;
    --trafic-light-red: rgb(var(--red));
    --trafic-light-red-glow:
      rgb(var(--red) / 40%) 0 0 4px 4px,
      rgb(var(--red) / 20%) 0 0 8px 8px;
  }

  .light {
    height: var(--light-size);
    width: var(--light-size);
    margin: 1rem;
    border-radius: 100%;
  }

  .green {
    background: var(--trafic-light-green);
    box-shadow: var(--trafic-light-green-glow);
  }

  .red {
    background: var(--trafic-light-red);
    box-shadow: var(--trafic-light-red-glow);
  }

  .label {
    font-size: small;
    color: grey;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
